import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksLinks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINKS,
	},
	getDoneWorksLinkPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_PREVIEW,
	},
	getDoneWorksLinkPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK_POPUP,
	},
	createDoneWorksLink: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].CREATE_DONE_WORKS_LINK,
	},
	getDoneWorksLink: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].GET_DONE_WORKS_LINK,
	},
	patchDoneWorksLink: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PATCH_DONE_WORKS_LINK,
	},
	putDoneWorksLink: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].PUT_DONE_WORKS_LINK,
	},
	deleteDoneWorksLink: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_LINKS].DELETE_DONE_WORKS_LINK,
	},
}